import { render, staticRenderFns } from "./PoolRatio.vue?vue&type=template&id=3f7b0f11&scoped=true&"
import script from "./PoolRatio.vue?vue&type=script&lang=js&"
export * from "./PoolRatio.vue?vue&type=script&lang=js&"
import style0 from "./PoolRatio.vue?vue&type=style&index=0&id=3f7b0f11&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7b0f11",
  null
  
)

export default component.exports